import { TreeNodeItem } from 'src/app/shared/models/tree/TreeNodeItem';
import { ICategory } from 'src/app/shared/models/category/ICategory';
import { CategoriesActionTypes } from '../../actions/categories/categories.actions';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export interface CategoriesState {
    categories: ICategory[];
    category: ICategory;
    item: TreeNodeItem;
    error: IResponseMessage;
    itemLoading: boolean;
    categoriesLoading: boolean;
}
const initialState: CategoriesState = {
    categories: [],
    category: null,
    item: null,
    error: null,
    itemLoading: false,
    categoriesLoading: false
};


export function categoriesReducer(state: CategoriesState = initialState, action: any): CategoriesState {
    switch (action.type) {
        case CategoriesActionTypes.GET_CATEGORIES: {
            return { ...state, categoriesLoading: true };
        }
        case CategoriesActionTypes.GET_CATEGORIES_SUCCESS: {
            return {
                ...state,
                categories: action.categories,
                categoriesLoading: false
            };
        }
        case CategoriesActionTypes.GET_CATEGORIES_ERROR: {
            return {
                ...state,
                error: action.error,
                categoriesLoading: false
            };
        }

        case CategoriesActionTypes.GET_ITEM: {
            return { ...state, itemLoading: true };
        }
        case CategoriesActionTypes.GET_ITEM_SUCCESS: {
            return {
                ...state,
                item: action.item,
                itemLoading: false
            };
        }
        case CategoriesActionTypes.GET_CATEGORY_SUCCESS: {
            return {
                ...state,
                category: action.category
            };
        }
        default:
            return state;
    }
}